(function () {
  if (window.__cardRatingInit) return;
  window.__cardRatingInit = true;

  var API = 'https://viorica-reviews-ro.fly.dev/reviews/productReviews/';
  var cache = new Map();
  var inflight = new Map();

  function buildStarsHTML(percent) {
    var base = '<div class="wt-rating__star"></div>'.repeat(5);
    var fill = '<div class="wt-rating__star-fill"></div>'.repeat(5);
    return (
      '<div class="wt-rating__stars">' +
      '<div class="wt-rating__base">' + base + '</div>' +
      '<div class="wt-rating__value" style="width:' + percent + '%;">' + fill + '</div>' +
      '</div>'
    );
  }

  function applyRating(el, data) {
    if (!data || !data.productReviews || !data.productReviews.length) return;
    var avg = data.overwallRating || 0;
    var count = data.totalApprovedReviews || 0;
    if (!count) return;

    var pct = avg * 20;
    var stars = el.querySelector('.card-rating__stars');
    if (stars) stars.innerHTML = buildStarsHTML(pct);
    var avgEl = el.querySelector('.card-rating__avg');
    var countEl = el.querySelector('.card-rating__count');
    if (avgEl) avgEl.textContent = avg.toFixed(1).replace('.', ',');
    if (countEl) countEl.textContent = '(' + count + ')';
    el.hidden = false;
    el.removeAttribute('aria-hidden');
  }

  function fetchRating(productId) {
    if (cache.has(productId)) return Promise.resolve(cache.get(productId));
    if (inflight.has(productId)) return inflight.get(productId);
    var p = fetch(API + productId)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) { cache.set(productId, data); inflight.delete(productId); return data; })
      .catch(function () { inflight.delete(productId); return null; });
    inflight.set(productId, p);
    return p;
  }

  function loadRating(el) {
    if (el.dataset.cardRatingLoaded) return;
    el.dataset.cardRatingLoaded = '1';
    var pid = el.dataset.productId;
    if (!pid) return;
    fetchRating(pid).then(function (data) { applyRating(el, data); });
  }

  var visibility = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries, instance) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          instance.unobserve(entry.target);
          loadRating(entry.target);
        });
      }, { rootMargin: '300px' })
    : null;

  function initRatingEl(el) {
    if (!el || el.dataset.cardRatingObserved) return;
    el.dataset.cardRatingObserved = '1';
    if (visibility) {
      visibility.observe(el);
    } else {
      loadRating(el);
    }
  }

  function scan(root) {
    var nodes = (root || document).querySelectorAll('.card-rating[data-product-id]:not([data-card-rating-observed])');
    nodes.forEach(initRatingEl);
  }

  function observe() {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches('.card-rating[data-product-id]')) {
            initRatingEl(n);
          } else if (n.querySelectorAll) {
            scan(n);
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function start() {
    scan(document);
    observe();
  }

  function schedule() {
    if (window.requestIdleCallback) {
      window.requestIdleCallback(start, { timeout: 2000 });
    } else {
      setTimeout(start, 200);
    }
  }

  if (document.readyState === 'complete') {
    schedule();
  } else {
    window.addEventListener('load', schedule);
  }
})();
